var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 5L7.4276 8.26414C9.55141 9.4675 10.4487 9.4675 12.5726 8.26414L18.3334 5",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67989 11.23C1.73436 13.7847 1.76161 15.0619 2.70421 16.0082C3.64681 16.9543 4.95869 16.9872 7.58244 17.0532C9.1995 17.0938 10.8007 17.0938 12.4177 17.0532C15.0415 16.9872 16.3533 16.9543 17.296 16.0082C18.2386 15.0619 18.2658 13.7847 18.3202 11.23C18.3378 10.4086 18.3378 9.59208 18.3202 8.77066C18.2658 6.21604 18.2386 4.93873 17.296 3.99254C16.3533 3.04635 15.0415 3.01339 12.4177 2.94747C10.8007 2.90683 9.1995 2.90683 7.58243 2.94746C4.95869 3.01338 3.64681 3.04633 2.70421 3.99253C1.7616 4.93873 1.73436 6.21603 1.67988 8.77066C1.66236 9.59208 1.66237 10.4086 1.67989 11.23Z",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcv);
export default __webpack_public_path__ + "static/media/mail_icv.7ab574cffa8dc54d2011d302b6c9949a.svg";
export { ForwardRef as ReactComponent };